<template>
  <div v-if="showSplash" class="splash">
    <!-- 轮播 -->
    <div
      class="swiper-container splash-swiper"
      ref="swiperRef"
      v-if="bannerList.length"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in bannerList"
          :key="item.id"
        >
          <img :src="item.covers" class="banner-img" />
        </div>
      </div>
    </div>

    <!-- 右下角 -->
    <div class="bottom-controls">
      <!-- 小圆点 -->
      <div class="dots">
        <span
          v-for="(item, index) in bannerList"
          :key="item.id"
          :class="['dot', current === index ? 'active' : '']"
        ></span>
      </div>

      <!-- 跳过 -->
      <div class="skip-btn" @click="closeSplash">跳过</div>
    </div>
  </div>

  <!-- 页面内容 -->
  <magazine-content v-else></magazine-content>
</template>

<script>
import Swiper from "swiper";
import axios from "axios";
import magazineContent from './components/magazine-content.vue';

export default {
  components: {
    magazineContent
  },
  data() {
    return {
      showSplash: false,
      current: 0,
      swiper: null,
      bannerList: [],
      pageTitle: "",
      pageData: "",
    };
  },

  mounted() {
    // 是否展示过
    // const splashShown = localStorage.getItem("splashShown");
    // if (splashShown) {
    //   this.showSplash = false;
    //   return;
    // }
    this.fetchBannerData();
  },

  methods: {
    // 获取url参数


    // 获取广告
    async fetchBannerData() {
      try {
        const res = await axios.post(
          "https://api.chccchina.com/api/v3/banner/query",
          {
            where: {
              Equal_ex: {
                n: "exhibitionId",
                v: "de8987b2-c5a1-4260-a8b9-28dde7a6027c",
              },
              Equal_position: {
                n: "position",
                v: "show.page.home.ad.magazine",
              },
              Equal_isdeleted: {
                n: "isDeleted",
                v: false,
              },
            },
            order: [
              {
                N: "showIndex",
                V: 1,
              },
            ],
            page: 1,
            size: 20,
          }
        );

        this.bannerList = res.data.items || [];

        this.$nextTick(() => {
          this.initSwiper();
        });
      } catch (err) {
        console.log(err);
      }
    },

    // 初始化swiper
    initSwiper() {
      if (!this.bannerList.length) return;
      this.swiper = new Swiper(this.$refs.swiperRef, {
        slidesPerView: 1,
        loop: false,
        observer: true,
        observeParents: true,
        on: {
          slideChange: () => {
            this.current = this.swiper.activeIndex;
          },
        },
      });
    },

    // 关闭
    closeSplash() {
      localStorage.setItem("splashShown", "true");

      this.showSplash = false;
    },
  },
};
</script>

<style scoped>
.splash {
  position: fixed;

  top: 0;
  left: 0;

  width: 100%;
  height: 100vh;

  z-index: 99999;

  overflow: hidden;
}

.splash-swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  width: 100%;
  height: 100vh;
}

.banner-img {
  width: 100%;
  height: 100%;


  display: block;
}

.bottom-controls {

  position: absolute;

  left: 0;
  right: 0;
  bottom: 40px;

  z-index: 100;

  display: flex;

  align-items: center;

  justify-content: center;

}

/* 圆点 */
.dots {

  display: flex;

  align-items: center;

}

.dot {

  width: 8px;
  height: 8px;

  border-radius: 50%;

  background: rgba(255,255,255,.4);

  margin: 0 4px;

}

.dot.active {

  background: #fff;

}

/* 跳过 */
.skip-btn {

  position: absolute;

  right: 24px;

  color: #fff;

  font-size: 14px;

  padding: 4px 10px;

  border-radius: 20px;

  background: rgba(0,0,0,.35);

}

/* 页面内容 */
.page-content {
  padding: 20px;
}
</style>